// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"981":"3f4227e0","7454":"8218ee53","8005":"8218ee53"}[chunkId] + ".chunk.css";
};